import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tab,
  Tabs,
  DialogContentText,
  Paper,
  ListItemText,
  List,
  ListItem
} from '@mui/material';
import {
  GridFooter,
  GridFooterContainer,
  GridSelectionModel,
  useGridApiRef,
  gridVisibleSortedRowIdsSelector,
  gridVisibleColumnDefinitionsSelector
} from '@mui/x-data-grid-pro';
import React, { useEffect, useRef, useState, memo } from 'react';
import '../studylogStyles.scss';
import AddIcon from '@mui/icons-material/Add';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useProtocolDeviationsLog } from './useProtocolDeviationsLog';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useUser } from 'src/components/hooks/useUser';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { setMessage } from 'src/store/Message';
import { hideLoader, showLoader } from 'src/store/Loader';
import DeleteProtocolDeviation from './DeleteProtocolDeviation';
import AddandUpdateProtocolDeviation from './AddandUpdateProtocolDeviation';
import PropTypes from 'prop-types';
import DataGridDeviationLog from './DataGridDeviationLog';
import Loader from 'src/components/common/Loader';
import { archLevel } from 'src/data/config';

const ProtocolDeviations = ({ setStudyLogOpen, setProtocolOn }: any) => {
  const handelBack = () => {
    setProtocolOn(false);
    setStudyLogOpen(true);
  };
  const { user, email } = useUser();
  const currentUserWithEmail = `${user} (${email})`;
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const [currentDeviatonLevel, setDeviatonLevel] = React.useState<string>('');
  const pdUpdatePermission = checkPermission(`update_${currentDeviatonLevel.toLowerCase()}_protocoldeviation`);
  const pdUpdateOtherPermission = checkPermission(
    `update_others_${currentDeviatonLevel.toLowerCase()}_protocoldeviation`
  );
  const pdUpdateActionPermission = checkPermission(
    `update_${currentDeviatonLevel.toLowerCase()}_protocoldeviation_action`
  );
  const pdUpdateDecisionPermission = checkPermission(
    `update_${currentDeviatonLevel.toLowerCase()}_protocoldeviation_decision`
  );
  const copyNewSponserPermission = checkPermission('copy_new_sponsor_deviation');
  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  const [selectedNos, setSelectedNos] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = useState(false);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const initialState = {
    created_by: user,
    deviation_level: currentDeviatonLevel,
    study_id: studyId,
    site_id: selectedSite,
    country: selectedCountry,
    application: 'CTMS',
    action_assigned_to: [],
    decision_assigned_to: []
  };
  const [createData, setCreateData] = useState<any>(initialState);
  const [updateData, setUpdateData] = useState<any>({
    updated_by: user,
    application: 'CTMS',
    action_assigned_to: [],
    decision_assigned_to: [],
    action_completion_dt: '',
    action_taken: '',
    dt_occur: '',
    issue_no: '',
    issue_id: '',
    decision_update: '',
    decision_comp_dt: '',
    id: ''
  });
  const [category, setCategory] = useState([]);
  const [severityPD, setSeverityPD] = useState([]);
  const [pdIdentification, setPdIdentification] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  const [submit, setSubmit] = useState(false);
  const componentRef = useRef<any>(null);
  const [error, setError] = useState(false);
  const [deleteData, setDeleteData] = useState<any>({});
  const [openDelete, setOpenDelete] = useState(false);
  const [atError, setAtError] = useState(false);
  const [daError, setDaError] = useState(false);
  const [duError, setDuError] = useState(false);
  const [ddError, setDdError] = useState(false);
  const { study_id: studyIdVal, country, site_id: siteIdVal, ...createDataRest } = createData;
  const [dataGridShow, setDataGridShow] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();

  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const [rows, setRows] = useState([]);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const { data: stisvewData } = useGetCodeListDataQuery('STISVEW');

  //site level permission //
  const updateSiteDeviationPermission = checkPermission('update_site_protocoldeviation');
  const updateSiteActionPermission = checkPermission('update_site_protocoldeviation_action');
  const updateSiteDecisionPermission = checkPermission('update_site_protocoldeviation_decision');
  const updateOtherSitePermission = checkPermission('update_others_site_protocoldeviation');
  const deleteOtherSitePermission = checkPermission('delete_others_site_protocoldeviation');
  // Sponsor level permission
  const updateSponsorDeviationPermission = checkPermission('update_sponsor_protocoldeviation');
  const updateSponsorActionPermission = checkPermission('update_sponsor_protocoldeviation_action');
  const updateSponsorDecisionPermission = checkPermission('update_sponsor_protocoldeviation_decision');
  const updateOtherSponsorPermission = checkPermission('update_others_sponsor_protocoldeviation');
  const deleteOtherSponsorPermission = checkPermission('delete_others_sponsor_protocoldeviation');
  // state for maintaining permision//
  const [deviationLogPermissions, setDeviationLogPermissions] = useState<any>({});
  const [value, setValue] = React.useState<number>(0);

  const apiRef = useGridApiRef();
  const coordinates = {
    rowIndex: 0,
    colIndex: 0
  };
  const [columnVisibilityModelSite, setColumnVisibilityModelSite] = useState({
    id: false,
    isSelected: false,
    pd_identification_options: false,
    action_taken_analysis: false
  });
  const [columnVisibilityModelSponsor, setColumnVisibilityModelSponsor] = useState({
    id: false,
    isSelected: false,
    pd_identification_options: true,
    action_taken_analysis: true
  });
  useEffect(() => {
    const arr: any = [];
    if (stisvewData) {
      stisvewData.map((item: any) => {
        arr.push(item.code_list_value);
      });
    }
  }, [stisvewData]);

  const dispatch = useAppDispatch();

  const {
    getProtocolDeviationLogData,
    protocolDeviationsData,
    protocolDeviationsIsLoading,
    protocolDeviationsIsError,
    protocolDeviationsError,
    createProtocolDeviationsLog,
    createProtocolDeviationsData,
    createProtocolDeviationsIsLoading,
    createProtocolDeviationsIsError,
    createProtocolDeviationsError,
    createProtocolDeviationsIsSuccess,
    updateProtocolDeviationsLog,
    updateProtocolDeviations,
    updateProtocolDeviationsIsLoading,
    updateProtocolDeviationsIsError,
    updateProtocolDeviationsError,
    updateProtocolDeviationsIsSuccess,
    updateDeviationAction,
    updateDeviationActionData,
    updateDeviationActionError,
    updateDeviationActionIsError,
    updateDeviationActionIsLoading,
    updateDeviationActionIsSuccess,
    updateDeviationDecision,
    updateDeviationDecisionData,
    updateDeviationDecisionError,
    updateDeviationDecisionIsError,
    updateDeviationDecisionIsLoading,
    updateDeviationDecisionIsSuccess,
    updateAllProtocolDeviationsLog,
    updateAllProtocolDeviations,
    updateAllProtocolDeviationsIsLoading,
    updateAllProtocolDeviationsIsError,
    updateAllProtocolDeviationsError,
    updateAllProtocolDeviationsIsSuccess,
    copyProtocolDeviationsLog,
    copyProtocolDeviationsIsError,
    copyProtocolDeviationsIsLoading,
    copyProtocolDeviationsError,
    copyProtocolDeviationsIsSuccess
  } = useProtocolDeviationsLog();

  useEffect(() => {
    if (archLevel == 'site' && archLevel != 'sponsor' && checkPermission('view_site_protocoldeviation')) {
      setDeviatonLevel('SITE');
    } else if (archLevel == 'sponsor' && archLevel != 'site' && checkPermission('view_site_protocoldeviation')) {
      setDeviatonLevel('SITE');
    } else if (archLevel == 'sponsor' && archLevel != 'site' && checkPermission('view_sponsor_protocoldeviation')) {
      setDeviatonLevel('SPONSOR');
    }
  }, []);

  useEffect(() => {
    if (value === 0 && currentDeviatonLevel === 'SITE') {
      setDeviationLogPermissions({
        update: updateSiteDeviationPermission,
        updateOther: updateOtherSitePermission,
        updateAction: updateSiteActionPermission,
        updateDecision: updateSiteDecisionPermission,
        deleteOther: deleteOtherSitePermission
      });
    } else {
      setDeviationLogPermissions({
        update: updateSponsorDeviationPermission,
        updateOther: updateOtherSponsorPermission,
        updateAction: updateSponsorActionPermission,
        updateDecision: updateSponsorDecisionPermission,
        deleteOther: deleteOtherSponsorPermission
      });
    }
  }, [value, currentDeviatonLevel]);

  const getProtocolData = async (from: number, size: number) => {
    if (currentDeviatonLevel !== '') {
      setDataGridShow(true);
      const tempDeviationLog = await getProtocolDeviationLogData({
        data: { ...filterObject },
        deviation_level: currentDeviatonLevel,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
        from,
        size
      });

      // setting rows from the response when there is data
      if (tempDeviationLog?.isSuccess) {
        setRowsCount(tempDeviationLog?.data.record_count);
        const tempRows: any = [];
        tempDeviationLog?.data &&
          tempDeviationLog?.data.selected_data.length > 0 &&
          tempDeviationLog?.data.selected_data.map((pd: any) => {
            const data = Object.assign({}, pd.deviation_details);
            data.action_req = data?.action_req ? 'Yes' : 'No';
            data.decision_req = data?.decision_req ? 'Yes' : 'No';
            tempRows.push({
              ...data,
              study_id: pd.study_id,
              country: pd.country,
              site_id: pd.site_id,
              id: data.id,
              action_assigned_to: pd.action_assigned_to !== null ? pd.action_assigned_to : [],
              decision_assigned_to: pd.decision_assigned_to !== null ? pd.decision_assigned_to : []
            });
          });
        if (tempRows.length > 0) {
          setRows(tempRows);
          if (apiRef) {
            const { rowIndex, colIndex } = coordinates;
            apiRef.current.scrollToIndexes(coordinates);
            const id = gridVisibleSortedRowIdsSelector(apiRef)[rowIndex];
            const column = gridVisibleColumnDefinitionsSelector(apiRef)[colIndex];
            column && apiRef.current.setCellFocus(id, column.field);
          }
        }
      } else if (tempDeviationLog?.isError) {
        setRowsCount(0);
        setPageNumber(0);
        setRows([]);
      }
    }
    setDataGridShow(false);
  };

  const getALlProgocolLogData = (from: number, size: number) => {
    if (currentDeviatonLevel !== '') {
      getProtocolData(from, size);
    }
  };
  useEffect(() => {
    getALlProgocolLogData(0, 10);
  }, [studyId, selectedCountry, selectedSite, value, currentDeviatonLevel, currentHierarchyLevel, openDelete]);

  useEffect(() => {
    if (!protocolDeviationsIsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getALlProgocolLogData(0, pageSize);
      } else {
        getALlProgocolLogData(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize, filterObject]);
  useEffect(() => {
    if (protocolDeviationsData) {
      if (!checkPermission('view_site_protocoldeviation') && !checkPermission('view_sponsor_protocoldeviation')) {
        setRows([]);
      }
    }
  }, [
    protocolDeviationsIsError,
    isHierarchyLevelClosed,
    protocolDeviationsIsLoading,
    selectedSite,
    value,
    currentHierarchyLevel
  ]);

  useEffect(() => {
    if (protocolDeviationsIsError) {
      setRows([]);
      const err: any = protocolDeviationsError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
  }, [protocolDeviationsIsError, protocolDeviationsError]);

  useEffect(() => {
    setRows([]);
  }, [currentDeviatonLevel, currentHierarchyLevel]);
  // Codelist APIs code //
  const { data: categoryData } = useGetCodeListDataQuery('SPDCAT');
  const { data: severityData } = useGetCodeListDataQuery('SPDSEV');
  const { data: pdIdentificationData } = useGetCodeListDataQuery('SPDIDEN');
  const { data: analysisData } = useGetCodeListDataQuery('SPDANAR');

  useEffect(() => {
    if (categoryData) {
      setCategory(categoryData);
    }
  }, [categoryData]);

  useEffect(() => {
    if (severityData) {
      setSeverityPD(severityData);
    }
  }, [severityData]);

  useEffect(() => {
    if (pdIdentificationData) {
      setPdIdentification(pdIdentificationData);
    }
  }, [pdIdentificationData]);

  useEffect(() => {
    if (analysisData) {
      setAnalysis(analysisData);
    }
  }, [analysisData]);

  // Loader //
  useEffect(() => {
    if (
      createProtocolDeviationsIsLoading ||
      updateProtocolDeviationsIsLoading ||
      updateDeviationActionIsLoading ||
      updateDeviationDecisionIsLoading ||
      updateAllProtocolDeviationsIsLoading ||
      copyProtocolDeviationsIsLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    createProtocolDeviationsIsLoading,
    updateProtocolDeviationsIsLoading,
    updateDeviationActionIsLoading,
    updateDeviationDecisionIsLoading,
    updateAllProtocolDeviationsIsLoading,
    copyProtocolDeviationsIsLoading
  ]);

  // onClick of Add deviation button //
  const handleAddDeviationOpen = () => {
    setEdit(false);
    setCreateData(initialState);
    setOpen(true);
  };

  // onClick of edit icon //
  const handelEdit = (data: any) => {
    setUpdateData({ ...data });
    setEdit(true);
    setOpen(true);
  };

  // onClick of delete icon //
  const handleDeleteOpen = (data: any) => {
    setDeleteData({ ...data, application: 'CTMS' });
    setOpenDelete(true);
  };

  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const buttonRef = useRef<any>();
  let createRequestObj = {};
  // onClick of save button in add and edit deviation popup //
  const handleSave = async () => {
    dispatch(showLoader());
    buttonRef.current.setAttribute('disabled', 'disabled');
    setDisableSubmit(true);
    setSubmit(true);
    if (edit) {
      if (
        (pdUpdatePermission || pdUpdateOtherPermission) &&
        updateData.study_id &&
        updateData.category &&
        updateData.severity &&
        updateData.dt_deviation &&
        (updateData.site_id ? updateData.subject_id : true) &&
        (updateData.reported_irb === 'Yes' || updateData.reported_irb === true ? updateData.date_irb : true) &&
        (updateData.action_req ? updateData.action_req : true) &&
        (updateData.action_taken ? updateData.action_completion_dt : true) &&
        (updateData.decision_update ? updateData.decision_comp_dt : true) &&
        (updateData.action_completion_dt ? updateData.action_taken : true) &&
        (updateData.decision_comp_dt ? updateData.decision_update : true)
      ) {
        if (updateData.action_completion_dt && updateData.action_completion_dt < updateData.dt_deviation) {
          dispatch(
            setMessage({
              msgDetails: 'Date of Action Completion cannot be lesser than Date of deviation identified',
              severity: 'error'
            })
          );
        } else if (updateData.decision_comp_dt && updateData.decision_comp_dt < updateData.dt_deviation) {
          dispatch(
            setMessage({
              msgDetails: 'Date of Decision completion cannot be lesser than Date of deviation identified',
              severity: 'error'
            })
          );
          componentRef.current.focus();
        } else if (updateData.created_by === user) {
          await updateProtocolDeviationsLog({
            data: updateData,
            deviation_level: currentDeviatonLevel
          });
          await getProtocolData(pageNumber * pageSize, pageSize);
        } else if (pdUpdateOtherPermission) {
          await updateAllProtocolDeviationsLog({
            data: updateData,
            deviation_level: currentDeviatonLevel
          });
          await getProtocolData(pageNumber * pageSize, pageSize);
        } else {
          const actionUser =
            updateData.action_assigned_to.length <= 0
              ? updateData.action_assigned_to
              : updateData.action_assigned_to.filter((name: string) => name === currentUserWithEmail);
          const decisionUser =
            updateData.decision_assigned_to.length <= 0
              ? updateData.decision_assigned_to
              : updateData.decision_assigned_to.filter((name: string) => name === currentUserWithEmail);
          updateData.action_req == 'Yes' && actionUser.length > 0 && handleDeviationAction();
          updateData.decision_req == 'Yes' && decisionUser.length > 0 && handleDeviationDecision();
          await getProtocolData(pageNumber * pageSize, pageSize);
        }
      } else {
        const actionUser =
          updateData.action_assigned_to.length <= 0
            ? updateData.action_assigned_to
            : updateData.action_assigned_to.filter((name: string) => name === currentUserWithEmail);
        const decisionUser =
          updateData.decision_assigned_to.length <= 0
            ? updateData.decision_assigned_to
            : updateData.decision_assigned_to.filter((name: string) => name === currentUserWithEmail);

        if (
          pdUpdateActionPermission &&
          actionUser.length > 0 &&
          pdUpdateDecisionPermission &&
          decisionUser.length > 0
        ) {
          handleActionAndDecision();
        } else if (pdUpdateActionPermission && actionUser.length > 0) {
          handleDeviationAction();
        } else if (pdUpdateDecisionPermission && decisionUser.length > 0) {
          handleDeviationDecision();
        }
      }
    } else {
      if (
        createData.study_id &&
        createData.category &&
        createData.severity &&
        createData.dt_deviation &&
        (createData.site_id ? createData.subject_id : true) &&
        (createData.reported_irb === 'Yes' || createData.reported_irb === true ? createData.date_irb : true) &&
        (createData.action_req ? createData.action_req : true) &&
        (createData.action_taken ? createData.action_completion_dt : true) &&
        (createData.decision_update ? createData.decision_comp_dt : true) &&
        (createData.action_completion_dt ? createData.action_taken : true) &&
        (createData.decision_comp_dt ? createData.decision_update : true)
      ) {
        if (createData.action_completion_dt && createData.action_completion_dt < createData.dt_deviation) {
          dispatch(
            setMessage({
              msgDetails: 'Date of Action Completion cannot be lesser than Date of deviation identified',
              severity: 'error'
            })
          );
        } else if (createData.decision_comp_dt && createData.decision_comp_dt < createData.dt_deviation) {
          dispatch(
            setMessage({
              msgDetails: 'Date of Decision completion cannot be lesser than Date of deviation identified',
              severity: 'error'
            })
          );
        } else {
          if (createRequestObj !== createDataRest) {
            createRequestObj = createDataRest;
            await createProtocolDeviationsLog({
              data: createDataRest,
              deviation_level: currentDeviatonLevel,
              study_id: createData.study_id,
              country: createData.country,
              site_id: createData.site_id
            });
          }
        }
      }
    }
    dispatch(hideLoader());
  };

  const handleDeviationAction = () => {
    if (
      updateData.action_completion_dt === null ||
      updateData.action_completion_dt === '' ||
      updateData.action_taken === null ||
      updateData.action_taken === ''
    ) {
      if (updateData.action_taken === null || updateData.action_taken === '') {
        setAtError(true);
      }
      if (updateData.action_completion_dt === null || updateData.action_completion_dt === '') {
        setDaError(true);
      }
      dispatch(
        setMessage({
          msgDetails: 'Date of Action Completion/Action Taken is blank',
          severity: 'error'
        })
      );
    } else if (updateData.action_completion_dt > new Date().toLocaleDateString('en-CA')) {
      dispatch(
        setMessage({
          msgDetails: 'Invalid or Future date entered',
          severity: 'error'
        })
      );
    } else if (updateData.action_completion_dt < updateData.dt_deviation) {
      setDaError(true);
      dispatch(
        setMessage({
          msgDetails: 'Date of Action Completion cannot be lesser than Date of deviation identified',
          severity: 'error'
        })
      );
    } else {
      updateDeviationAction({
        id: updateData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: 'CTMS',
        deviation_level: currentDeviatonLevel,
        data: { action_taken: updateData.action_taken, action_completion_date: updateData.action_completion_dt }
      });
      setOpen(false);
    }
  };

  const handleDeviationDecision = () => {
    if (
      updateData.decision_comp_dt === null ||
      updateData.decision_comp_dt === '' ||
      updateData.decision_update === ''
    ) {
      if (updateData.decision_update === null || updateData.decision_update === '') {
        setDuError(true);
      }
      if (updateData.decision_comp_dt === null || updateData.decision_comp_dt === '') {
        setDdError(true);
      }
      dispatch(
        setMessage({
          msgDetails: 'Decision Update/Date of Decision Completion is blank',
          severity: 'error'
        })
      );
    } else if (updateData.decision_comp_dt > new Date().toLocaleDateString('en-CA')) {
      dispatch(
        setMessage({
          msgDetails: 'Invalid or Future date entered',
          severity: 'error'
        })
      );
    } else if (updateData.decision_comp_dt < updateData.dt_deviation) {
      setDdError(true);
      dispatch(
        setMessage({
          msgDetails: 'Date of Decision completion cannot be lesser than Date of deviation identified',
          severity: 'error'
        })
      );
      componentRef.current.focus();
    } else {
      updateDeviationDecision({
        id: updateData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: 'CTMS',
        deviation_level: currentDeviatonLevel,
        data: { decision_update: updateData.decision_update, decision_completion_date: updateData.decision_comp_dt }
      });
      setOpen(false);
    }
  };

  const handleActionAndDecision = async () => {
    if (
      updateData.action_req === 'Yes' &&
      (updateData.action_completion_dt === null ||
        updateData.action_completion_dt === '' ||
        updateData.action_taken === null ||
        updateData.action_taken === '')
    ) {
      if (updateData.action_taken === null || updateData.action_taken === '') {
        setAtError(true);
      }
      if (updateData.action_completion_dt === null || updateData.action_completion_dt === '') {
        setDaError(true);
      }
      dispatch(
        setMessage({
          msgDetails: 'Date of Action Completion/Action Taken is blank',
          severity: 'error'
        })
      );
    } else if (updateData.action_req === 'Yes' && updateData.action_completion_dt < updateData.dt_deviation) {
      setDaError(true);
      dispatch(
        setMessage({
          msgDetails: 'Date of Action Completion cannot be lesser than Date of deviation identified',
          severity: 'error'
        })
      );
    } else if (
      updateData.decision_req === 'Yes' &&
      (updateData.decision_comp_dt === null || updateData.decision_comp_dt === '' || updateData.decision_update === '')
    ) {
      if (updateData.decision_update === null || updateData.decision_update === '') {
        setDuError(true);
      }
      if (updateData.decision_comp_dt === null || updateData.decision_comp_dt === '') {
        setDdError(true);
      }
      dispatch(
        setMessage({
          msgDetails: 'Decision Update/Date of Decision Completion is blank',
          severity: 'error'
        })
      );
    } else if (
      updateData.action_completion_dt > new Date().toLocaleDateString('en-CA') ||
      updateData.decision_comp_dt > new Date().toLocaleDateString('en-CA')
    ) {
      dispatch(
        setMessage({
          msgDetails: 'Invalid or Future date entered',
          severity: 'error'
        })
      );
    } else if (updateData.decision_req === 'Yes' && updateData.decision_comp_dt < updateData.dt_deviation) {
      setDdError(true);
      dispatch(
        setMessage({
          msgDetails: 'Date of Decision completion cannot be lesser than Date of deviation identified',
          severity: 'error'
        })
      );
      componentRef.current.focus();
    } else {
      await updateDeviationAction({
        id: updateData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: 'CTMS',
        deviation_level: currentDeviatonLevel,
        data: { action_taken: updateData.action_taken, action_completion_date: updateData.action_completion_dt }
      });
      await updateDeviationDecision({
        id: updateData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: 'CTMS',
        deviation_level: currentDeviatonLevel,
        data: { decision_update: updateData.decision_update, decision_completion_date: updateData.decision_comp_dt }
      });
      setOpen(false);
    }
  };
  const handleClickOpen = () => {
    setEdit(false);
    setCreateData(initialState);
    setOpen(true);
  };

  const handleClose = () => {
    setSubmit(false);
    setError(false);
    setAtError(false);
    setDaError(false);
    setDuError(false);
    setDdError(false);
    setOpen(false);
  };

  // Render on success and error of create protocol deviation //
  useEffect(() => {
    setDisableSubmit(false);
    if (createProtocolDeviationsIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: 'Protocol Deviation created successfully ',
          severity: 'success'
        })
      );
      getProtocolData(pageNumber * pageSize, pageSize);
    }
    if (createProtocolDeviationsIsError) {
      const err: any = createProtocolDeviationsError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error in creating protocol deviation',
            severity: 'error'
          })
        );
      }
    }
    dispatch(hideLoader());
  }, [createProtocolDeviationsIsSuccess, createProtocolDeviationsIsError, createProtocolDeviationsData]);

  // Render on success and error of update/updateAll protocol deviation //
  useEffect(() => {
    setDisableSubmit(false);
    if (updateProtocolDeviationsIsSuccess || updateAllProtocolDeviationsIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: 'Protocol deviation updated successfully',
          severity: 'success'
        })
      );
      getProtocolData(pageNumber * pageSize, pageSize);
    }
    if (updateProtocolDeviationsIsError || updateAllProtocolDeviationsIsError) {
      const err: any = updateProtocolDeviationsError || updateAllProtocolDeviationsError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error in updating protocol deviation',
            severity: 'error'
          })
        );
      }
    }
    dispatch(hideLoader());
  }, [
    updateProtocolDeviationsIsSuccess,
    updateAllProtocolDeviationsIsSuccess,
    updateProtocolDeviationsIsError,
    updateAllProtocolDeviationsIsError,
    updateProtocolDeviations,
    updateAllProtocolDeviations
  ]);

  // Render on success and error of action/decision update protocol deviation //
  useEffect(() => {
    setDisableSubmit(false);
    if (updateDeviationActionIsSuccess || updateDeviationDecisionIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: 'Protocol deviation updated successfully',
          severity: 'success'
        })
      );
      getProtocolData(pageNumber * pageSize, pageSize);
    }
    if (updateDeviationActionIsError || updateDeviationDecisionIsError) {
      const err: any = updateDeviationActionError || updateDeviationDecisionError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error in updating protocol deviation',
            severity: 'error'
          })
        );
      }
    }
    dispatch(hideLoader());
  }, [
    updateDeviationActionIsSuccess,
    updateDeviationDecisionIsSuccess,
    updateDeviationActionIsError,
    updateDeviationDecisionError,
    updateDeviationActionData,
    updateDeviationDecisionData
  ]);

  // Render when there is error for edit fields//
  useEffect(() => {
    if (createData.action_taken || updateData.action_taken) {
      setAtError(false);
    }
    if (createData.action_completion_dt || updateData.action_completion_dt) {
      setDaError(false);
    }
    if (createData.decision_update || updateData.decision_update) {
      setDuError(false);
    }
    if (createData.decision_comp_dt || updateData.decision_comp_dt) {
      setDdError(false);
    }
  }, [
    createData.action_taken,
    createData.action_completion_dt,
    createData.decision_update,
    createData.decision_comp_dt,
    updateData.action_taken,
    updateData.action_completion_dt,
    updateData.decision_update,
    updateData.decision_comp_dt
  ]);
  // for Custom buttons at bottom in Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }}>
          {deviationLogPermissions.update ? (
            <Button
              disabled={!((currentDeviatonLevel == 'SITE' && selectedSite != null) || currentDeviatonLevel !== 'SITE')}
              startIcon={<AddIcon />}
              onClick={handleAddDeviationOpen}
            >
              Add Deviation
            </Button>
          ) : null}

          {currentDeviatonLevel == 'SITE' && copyNewSponserPermission && selectedSite !== null ? (
            <Button
              variant="contained"
              disabled={selectionModel.length === 0 ? true : false}
              onClick={handleOpenCopyToSponsor}
              sx={{ letterSpacing: '-0.25px', padding: '6px 8px' }}
            >
              COPY AS NEW SPONSOR DEVIATION
            </Button>
          ) : null}
        </Box>
        <GridFooter />
      </GridFooterContainer>
    );
  }

  function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  const handleTabsChange = (event: React.SyntheticEvent, newValue: number) => {
    setRowsCount(0);
    setPageNumber(0);
    setPageSize(10);
    setValue(newValue);
    setRows([]);
    newValue === 0 ? setDeviatonLevel('SITE') : setDeviatonLevel('SPONSOR');
  };

  //Copy deviation to sponsor
  const handleOpenCopyToSponsor = async () => {
    dispatch(showLoader());
    const tempSponsorData = await getProtocolDeviationLogData({
      data: { ...filterObject },
      deviation_level: 'SPONSOR',
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME
    });
    if (tempSponsorData?.isSuccess) {
      const sponsorList =
        tempSponsorData.data && tempSponsorData.data.selected_data.length > 0
          ? tempSponsorData.data.selected_data.map((item: any) => item.deviation_details.cloned_deviation_no)
          : [];
      const copiedNos = selectedNos.filter((item: any) => sponsorList.includes(item));
      const remainingNos = selectedNos.filter((item: any) => !sponsorList.includes(item));

      if (remainingNos.length === 0) {
        dispatch(
          setMessage({
            msgDetails: 'Selected Protocol deviation(s) already copied to Sponsor',
            severity: 'error'
          })
        );
        setConfirmOpen(false);
      } else {
        setConfirmOpen(true);
        if (copiedNos.length !== 0) {
          dispatch(
            setMessage({
              msgDetails: 'Some of the selected Protocol deviations are already copied to Sponsor',
              severity: 'error'
            })
          );
        }
        setSelectedNos(remainingNos);
      }
    } else if (tempSponsorData?.isError) {
      setSelectedNos(selectedNos);
      setConfirmOpen(true);
    }
    dispatch(hideLoader());
  };

  const handleCloseCopyToSponsor = () => {
    setConfirmOpen(false);
  };

  const handleConfirmCopyToSponsor = async () => {
    await copyProtocolDeviationsLog({
      study_id: studyId,
      site_id: selectedSite,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      data: { deviation_no_list: selectedNos }
    });
  };

  useEffect(() => {
    if (copyProtocolDeviationsIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Protocol deviation(s) created successfully',
          severity: 'success'
        })
      );
      setDeviatonLevel('SPONSOR');
      setValue(1);
      setDataGridShow(true);
      setSelectionModel([]);
      setConfirmOpen(false);
    } else if (copyProtocolDeviationsIsError) {
      const errorCopy: any = copyProtocolDeviationsError;
      if (errorCopy?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${errorCopy?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorCopy?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (errorCopy?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error in copy to sponsor protocol deviation(s)',
            severity: 'error'
          })
        );
      }
    }
  }, [copyProtocolDeviationsIsSuccess, copyProtocolDeviationsIsError]);
  // checkbox selection
  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const rowSelected = rows
      .filter((row: any) => selectedIds.has(row.id))
      .map((elem: any) => elem.deviation_no)
      .sort();
    setSelectedNos(rowSelected);
  };

  return (
    <div>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button onClick={handelBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          LIST OF LOGS
        </Button>
      </Box>
      <Grid container spacing={2} alignItems="center" className="titleGrid">
        <Grid item xs>
          <Stack direction="row" spacing={4} alignItems="center">
            <Typography variant="h6" component="h6" sx={{ height: '35px' }}>
              Protocol Deviations
            </Typography>
          </Stack>
        </Grid>
        <Grid item sx={{ textAlign: 'right' }}>
          <Button variant="contained" style={{ textTransform: 'none' }}>
            {value ? 'PUBLISH TO eTMF' : 'PUBLISH TO eISF'}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ width: '100%' }}>
        {archLevel == 'site' && archLevel != 'sponsor' && checkPermission('view_site_protocoldeviation') ? (
          <Tabs
            value={value}
            onChange={handleTabsChange}
            aria-label="Subject Tracking Tabs"
            className="tabsFontSize extendedTabs"
          >
            <Tab label="Site" {...a11yProps(0)} />
          </Tabs>
        ) : (
          ''
        )}
        {archLevel == 'sponsor' && archLevel != 'site' ? (
          <Tabs
            value={value}
            onChange={handleTabsChange}
            aria-label="Subject Tracking Tabs"
            className="tabsFontSize extendedTabs"
          >
            {checkPermission('view_site_protocoldeviation') && <Tab label="Site" {...a11yProps(0)} />}
            {checkPermission('view_sponsor_protocoldeviation') && <Tab label="Sponsor" {...a11yProps(1)} />}
          </Tabs>
        ) : (
          ''
        )}

        <DataGridDeviationLog
          rows={rows}
          rowsCount={rowsCount}
          page={pageNumber}
          pageSize={pageSize}
          setPageSize={setPageSize}
          apiRef={apiRef}
          handleClickOpen={handleClickOpen}
          handleDeleteOpen={handleDeleteOpen}
          handelEdit={handelEdit}
          CustomFooterButtons={CustomFooterButtons}
          deviationLogPermissions={deviationLogPermissions}
          currentDiviationLevel={currentDeviatonLevel}
          isLoading={dataGridShow}
          checkboxSelection={
            selectedSite !== null ? (copyNewSponserPermission && currentDeviatonLevel === 'SITE' ? true : false) : false
          }
          checkboxSelectionVisibleOnly
          selectionModel={selectionModel}
          onSelectionModelChange={(newValue: any) => onSelectionModelChange(newValue)}
          columnVisibilityModel={
            currentDeviatonLevel === 'SITE' ? columnVisibilityModelSite : columnVisibilityModelSponsor
          }
          setColumnVisibilityModel={
            currentDeviatonLevel === 'SITE' ? setColumnVisibilityModelSite : setColumnVisibilityModelSponsor
          }
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          setFilterObject={setFilterObject}
        />
      </Box>
      <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
        <Loader />
        <DialogTitle>{edit ? 'Edit' : 'Add'} Deviation</DialogTitle>
        <DialogContent className="modal800">
          <AddandUpdateProtocolDeviation
            createData={createData}
            setCreateData={setCreateData}
            edit={edit}
            updateData={updateData}
            setUpdateData={setUpdateData}
            category={category}
            severityPD={severityPD}
            pdIdentification={pdIdentification}
            analysis={analysis}
            initialState={initialState}
            submit={submit}
            componentRef={componentRef}
            error={error}
            atError={atError}
            daError={daError}
            duError={duError}
            ddError={ddError}
            deviationLevel={currentDeviatonLevel}
            deviationLogPermissions={deviationLogPermissions}
            setDisableSubmit={setDisableSubmit}
            selectedSite={selectedSite}
          />
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} ref={buttonRef} disabled={disableSubmit}>
            Save
          </Button>
        </DialogActions>
      </PopupComponent>
      <DeleteProtocolDeviation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        deleteData={deleteData}
        deviationLevel={currentDeviatonLevel}
        pageSize={pageSize}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />

      <Box className="Sign_aggrement_statement">
        {currentDeviatonLevel == 'SITE' ? (
          <Grid container rowSpacing={2} mt={2} columnSpacing={10}>
            <Grid item md={6}>
              <Typography variant="h6" mb={1.5}>
                Study Completion:
              </Typography>
              <Typography>
                I, for the protocol identified above, verify that the delegated tasks were performed under my
                supervision.
              </Typography>
            </Grid>
            <Grid item md={9}>
              <Stack direction="row" spacing={2}>
                <Button variant="contained" disabled>
                  Sign
                </Button>
              </Stack>
            </Grid>
          </Grid>
        ) : null}
      </Box>
      <PopupComponent open={confirmOpen} onClose={handleCloseCopyToSponsor} className="smallDialogs">
        <Loader />
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent className="tsda_prescreenDialog">
          <DialogContentText>
            <Typography my={1} sx={{ color: 'rgba(0,0,0,0.87)' }}>
              Would you like to copy the following Protocol deviation(s) to Sponsor protocol deviations?
            </Typography>
          </DialogContentText>

          <Paper sx={{ width: '100%', height: '200px', bgcolor: 'background.paper', overflowY: 'auto', mb: -2 }}>
            <List dense component="nav">
              {selectedNos.map((id: any, i: number) => (
                <ListItem key={i} disablePadding>
                  <ListItemText primary={id} sx={{ padding: '5px', paddingLeft: '13px' }} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleCloseCopyToSponsor}>
            Cancel
          </Button>
          <Button onClick={handleConfirmCopyToSponsor} disabled={selectedNos.length === 0}>
            Confirm
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};

export default memo(ProtocolDeviations);
